import React from 'react'
import { Modal } from 'rsuite'
import QRCode from "react-qr-code"
import { useFetchGetDeviceAdminToken } from '@@partner:graphql/query/device/getDeviceAdminToken.gql'
import AppLoader from '@components/common/AppLoader'

type DeviceAdminQRModalProps = {
  open: boolean
  onClose: () => void
}

export default function DeviceAdminQRModal ({
  open,
  onClose
}: DeviceAdminQRModalProps) {

  const { data, loading } = useFetchGetDeviceAdminToken()


  return (
    <Modal
      size='md'
      overflow={true}
      open={open} 
      onClose={onClose}
    >
      <Modal.Header>QR-код</Modal.Header>
      <Modal.Body>
        <div className='flex justify-center items-center h-full'>
          { loading ? (
            <AppLoader.Spinner />
          ) : (
            <QRCode
              value={data?.getDeviceAdminToken || ''}
            />
          )}
        </div>
        <div className='flex justify-center items-center h-full'>
          <p className='text-center'>
            Отсканируйте QR-код для доступа к админке устройства.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className='btn btn-primary'
          onClick={onClose}
        >
          Закрыть
        </button>
      </Modal.Footer>
    </Modal>
  )
}